import SVG from "../SVG";

export default function InputPayment({
  className,
  inputClassName,
  svgName,
  svgClassName,
  id,
  name,
  type,
  options = [],
  placeholder,
  state,
  setState,
  disabled,
  value,
  onChange,
  inputMode,
}) {
  const allOptions = [placeholder, ...options];
  const controlledValue = value !== undefined ? value : state;
  const handleTextChange =
    onChange ??
    (setState
      ? (e) => {
          setState(e.target.value);
        }
      : undefined);

  return (
    <div className={`relative inline-flex items-center w-full ${className}`}>
      {type === "select" ? (
        <select
          className={`appearance-none bg-transparent ${inputClassName}`}
          id={id}
          name={name}
          onChange={(e) => {
            if (!setState) return;
            if (e.target.value === "در انتظار") setState("pending");
            else if (e.target.value === "تایید شده") setState("approved");
            else if (e.target.value === "تکمیل شده") setState("completed");
            else if (e.target.value === "رد شده") setState("rejected");
            else setState(e.target.value);
          }}
          value={
            state === "pending"
              ? "در انتظار"
              : state === "approved"
              ? "تایید شده"
              : state === "completed"
              ? "تکمیل شده"
              : state === "rejected" || state === "failed"
              ? "رد شده"
              : ""
          }
          disabled={disabled}
        >
          {allOptions.map((opt, index) => (
            <option
              key={index}
              value={index === 0 ? "" : opt}
              disabled={index === 0}
              className="text-zi-text-light"
            >
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <input
          className={`bg-transparent ${inputClassName}`}
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          value={controlledValue !== undefined ? controlledValue : undefined}
          onChange={handleTextChange}
          disabled={disabled}
          inputMode={inputMode}
        />
      )}

      <div className="pointer-events-none absolute left-3 flex items-center">
        <SVG name={svgName} classname={svgClassName} />
      </div>
    </div>
  );
}
